<div class="splash-header"></div>
